import React from "react";
import { Component } from "react";
import {
    View,
    TouchableOpacity,
    Dimensions,
    ScrollView,
    TextInput,
    Platform,
    Keyboard,
} from "react-native";
import { Image } from 'expo-image'
import { WHITE } from "react-native-material-color";
// import ActionSheet from 'react-native-actionsheet';
import Slideshow from "../components/react-native-slideshow";
import * as Styles from "../utils/Styles";
import * as AppStyles from "../utils/appStyles";
import * as Commons from "../utils/Commons";
import { STRINGS } from "../utils/Strings";
import Text from "../components/Text";
import * as Constants from "../utils/Constants";
import * as ServerOperations from "../utils/ServerOperations";
import loaderHandler from "../components/react-native-busy-indicator/LoaderHandler";
import { SafeAreaInsetsContext } from "react-native-safe-area-context";
let height = Dimensions.get("window").height;
let width = Commons.getWidth();
let styles = {};
let isMobile = false;
let scale = 1;
const giftIcon = require("../images/CheckOut/greengiftIcon.png");
const leftArrow = require("../images/home/leftArrow.png");
const minus = require("../images/Shop/minus.png");
const plus = require("../images/Shop/plus.png");
let part1Width = 0;
let part2Width = 0;
let products = [];
let language = '';


class ProductDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            consumerBrands: [],
            products: [],
            isAdded: false,
            itemsNo: 0,
            product: '',
            itemQty: 0,
            bonusPlus: 0,
            selectedImgIndex: 0,
            qtyInputFocused: false,
            keyboardHeight: 0,
        };
    }
    Pressables = {};

    async componentDidMount() {
        loaderHandler.showLoader(STRINGS.loading, this);
        language = await Commons.language();

        // Android edge-to-edge ignores adjustResize, so the footer is lifted manually.
        this.keyboardShowSub = Keyboard.addListener(
            Platform.OS === 'ios' ? 'keyboardWillShow' : 'keyboardDidShow',
            (e) => this.setState({ keyboardHeight: e?.endCoordinates?.height || 0 })
        );
        this.keyboardHideSub = Keyboard.addListener(
            Platform.OS === 'ios' ? 'keyboardWillHide' : 'keyboardDidHide',
            () => this.setState({ keyboardHeight: 0, qtyInputFocused: false })
        );

        // Add browser back button handling for web
        if (typeof window !== 'undefined' && window.addEventListener) {
            window.addEventListener('popstate', this.handleBackButton);

            // Push current state to history for better navigation
            const currentState = {
                page: 'productDetails',
                timestamp: Date.now()
            };
            window.history.pushState(currentState, 'Product Details', window.location.pathname);
        }

        await this.loadData();
        setTimeout(() => {
            loaderHandler.hideLoader();
        }, 250);
    }

    componentWillUnmount() {
        this.keyboardShowSub?.remove();
        this.keyboardHideSub?.remove();
        // Clean up event listener
        if (typeof window !== 'undefined' && window.removeEventListener) {
            window.removeEventListener('popstate', this.handleBackButton);
        }
    }

    focusQtyInput = (itemID) => {
        this.setState({
            [`itemQty${itemID}`]: this.state[`itemQty${itemID}`] ? this.state[`itemQty${itemID}`] : 1,
            qtyInputFocused: true,
        });
    }

    handleBackButton = (event) => {
        // Handle back button press - close product details
        this.closeProductDetails();

        // Prevent default browser back behavior if needed
        // You can remove this if you want normal browser back behavior
        if (event.state && event.state.page === 'productDetails' && window.location.pathname) {
            // Custom handling - stay on current page but close modal/details
            window.history.pushState(event.state, 'Product Details', window.location.pathname);
        }
    }

    closeProductDetails = () => {
        const { showProductsDetails } = this.props;
        if (typeof showProductsDetails === 'function') {
            showProductsDetails(false);
        }


        // Optional: Navigate to shop page if no parent handler
        // window.location = './shop';
    }

    deleteProduct = () => {
        if (this.addToBasketTimeout) {
            clearTimeout(this.addToBasketTimeout);
        }

        // Set new timeout to wait 500ms before calling addItemsToBasket
        this.addToBasketTimeout = setTimeout(() => {
            console.log('Deleting item from basket:', this.props.item);
            Commons.deleteItemsFromBasket(this, this.state.products[0], this.state.products[0].ID, this.loadData);
        }, 500);

    }

    updateProduct = (product) => {
        // Cancel previous timeout if it exists
        if (this.addToBasketTimeout) {
            clearTimeout(this.addToBasketTimeout);
        }

        // Set new timeout to wait 500ms before calling addItemsToBasket
        this.addToBasketTimeout = setTimeout(() => {
            Commons.addItemsToBasket(this, product, product.ID, product.qty, this.loadData);
        }, 500);
    }



    loadData = async () => {
        // loaderHandler.showLoader(STRINGS.loading, this);
        const productID = this.state.productID || this.props.productID;
        // const brandsResp = await ServerOperations.getBrands();
        if (!this.state.products || this.state.products.length === 0 || (this.state.products[0] && this.state.products[0].ID !== productID)) {
            const productsResp = await ServerOperations.getProducts(productID, '', '', '');
            if (productsResp) {
                productsResp.forEach(item => {
                    this.setState({ product: item, products: [item] });
                });
            }
            this.setState({
                productID
            });
        }
        // products = productsResp;
        // const itemsInBasket = await Commons.getFromAS(Constants.ITEMS_IN_BASKET);
        // if (itemsInBasket) {
        //     const parsedItems = JSON.parse(itemsInBasket);
        //     parsedItems.forEach(item => {
        //         if (item.ID === this.props.productID) {
        //             products = [item];
        //             this.setState({ bonusPlus: item.BONUS });
        //         }
        //     });
        //     this.setState({ itemsNo: parsedItems.length });
        // } else {
        //     this.setState({ itemsNo: 0 });
        // }
        Commons.checkItemIsInBasket(this, productID).then((res) => {
            console.log('checkItemIsInBasket', res);
            if (res.item)
                this.setState({ itemQty: res.qty, product: res.item, products: [res.item], isAdded: res.inBasket });
        });
        // loaderHandler.hideLoader();
    }

    renderHeader = () => {
        return (
            <View style={{
                flexDirection: 'row', alignItems: 'center', padding: 20, alignSelf: "stretch", justifyContent: "space-between",
                backgroundColor: isMobile ? 'whitransparentte' : 'transparent',
                zIndex: 99,
                position: 'absolute',
                top: isMobile ? 0 : 15,
                left: 15
            }}>
                <TouchableOpacity
                    onPress={() => {
                        this.closeProductDetails();
                    }}
                    style={{ flexDirection: 'row', alignItems: 'center', gap: 8, justifyContent: 'center' }}
                >
                    <Image source={leftArrow} style={{ width: 9, height: 9 }} />
                    <Text style={[AppStyles.LabelTextStyles, { fontSize: 16, textTransform: 'capitalize' }]}>{STRINGS.back}</Text>
                </TouchableOpacity>
            </View>
        )
    }

    renderMobile() {
        scale = width / 420;
        return (
            <View style={styles.container}>
                {/* {Commons.renderAppHeader({}, this)} */}
                {this.renderHeader()}
                {Commons.loadFonts(this, false)}
                <ScrollView
                    style={{ flex: 1, alignSelf: 'stretch' }}
                    contentContainerStyle={{ paddingBottom: 16 }}
                    ref={ref => this.mainScrollView = ref}
                    scrollEventThrottle={200}
                    keyboardShouldPersistTaps="handled"
                    keyboardDismissMode="interactive"
                    showsVerticalScrollIndicator={false}
                    onScroll={(e) => Commons.onHeaderScroll(e, this)}>
                    <View style={{ width }}>
                        {this.renderPart1Mobile()}
                    </View>
                    {/* {Commons.renderAppFooter({}, this)} */}
                </ScrollView>
                <View style={{ alignSelf: 'stretch' }}>
                    {this.addToCartButton(this.state.product, this.state.productID)}
                </View>
            </View>
        );
    }

    renderAwaitingRestock(item) {
        if (item.OOS != "1") return null;
        return (
            <View style={{
                position: 'absolute',
                top: isMobile ? 80 : 100,
                left: isMobile ? 32 : 16,
                zIndex: 4,
                backgroundColor: '#FF8E3D',
                borderRadius: 10,
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 10,
                height: 31,
                paddingHorizontal: 16
            }}>
                <Text style={{ color: '#FFFFFF', fontSize: 11, fontFamily: AppStyles.fontFamily, fontWeight: 700 }}>{STRINGS.awaiting_restock}</Text>
            </View>
        );
    }

    render() {
        this.title = 'Product Details';
        width = Dimensions.get("window").width;
        isMobile = Commons.isMobile();
        if (isMobile) {
            Commons.resizeHandle(window, this, () => {
                width = this.width;
                // height = this.height;
            });
            styles = this.styles();
            return this.renderMobile();
        }
        width = (Commons.getDesktopWidth());
        height = (Commons.getDesktopHeight());
        styles = this.styles();

        return (
            <View style={[styles.container, { paddingLeft: 20, backgroundColor: '#fff' }]}>
                <ScrollView
                    ref={ref => this.mainScrollView = ref}
                    scrollEventThrottle={200} showsVerticalScrollIndicator={false} onScroll={(e) => Commons.onHeaderScroll(e, this)}>
                    <View style={{ width, height }}>
                        {this.renderHeader()}
                        {this.renderPart1()}
                    </View>
                </ScrollView>
            </View >
        );
    }


    renderImgs = () => {
        return (
            <Slideshow
                dataSource={this.state.products.map(item => ({
                    url: item.IMG,
                    // You can add title/caption if needed
                }))}
                arrowSize={24}
                indicatorSize={8}
                indicatorColor="#52C0EE"
                autoPlay={true}
                autoPlayInterval={3000}
                arrowRight={<View />}
                arrowLeft={<View />}
                scrollEnabled={true}
                containerStyle={{
                    borderRadius: 12,
                    overflow: 'hidden',
                }}
            // filterID={this.state.filterID}
            // isAdvProducts={this.state.isAdvProducts}
            // showOrderNow={(show) => {
            //     this.setState({
            //         showOrderNow: show, filterID: '', isAdv: show,
            //         featuredItems: this.state.featuredItems.slice(), bestSellers: this.state.bestSellers.slice()
            //     });

            // }}
            // onTouch={(index) => {
            //     const item = this.state.advs[index];
            //     this.setState({ filterID: '', isAdv: true, isAdvProducts: item.ITEMS, showOrderNow: true });
            //     console.log(item.ITEMS);
            // }}
            // Add other props as needed
            />
        )
    }


    renderPart1 = () => {
        const item = this.state.products && this.state.products[0] || "X";
        console.log('renderPart1 item', item);
        if (item == "X") {
            return null;
        }

        try {

            // Split BON_LIST into rows of 3 items each, guarding against BON_LIST
            // sometimes being a non-array (e.g. an empty string) from the API.
            const bonListRows = Array.isArray(item.BON_LIST)
                ? Array.from({ length: Math.ceil(item.BON_LIST.length / 4) }, (_, i) =>
                    item.BON_LIST.slice(i * 4, i * 4 + 4)
                )
                : [];

            part1Width = Math.max((width - 110) / 2, 350);
            if (part1Width > (height - 180)) {
                part1Width = height - 180;
            }
            let minWidth = width / 2;
            part2Width = width - Math.max(part1Width, minWidth) - 70;


            let imgsScale = (Math.max(part1Width, minWidth) - 40) / item.IMGS.length / 116;
            imgsScale = 1;
            if (imgsScale > 1) imgsScale = 1;
            if (imgsScale < 0.7) imgsScale = 0.7;

            let linkedImgsScale = (part2Width - 70) / 4 / 116;
            if (linkedImgsScale > 1) linkedImgsScale = 1;
            if (linkedImgsScale < 0.6) linkedImgsScale = 0.6;

            const thumbDim = 80 * imgsScale;
            const thumbSize = thumbDim + 25; // 90px image + 10px padding each side
            const imagesPerRow = Math.max(1, Math.floor((Math.max(part1Width, minWidth) - 70) / thumbSize));
            const rows = [];

            if (item.IMGS.length > imagesPerRow) {
                for (let i = 0; i < item.IMGS.length; i += imagesPerRow) {
                    const rowImgs = item.IMGS.slice(i, i + imagesPerRow);
                    // Pad the last row with `null` (not a JSX element!) so the renderer's
                    // `img ? <Image source={{ uri: img }} /> : <View />` ternary falls through
                    // to the empty placeholder branch instead of passing a React element as
                    // an Image `uri`, which crashes the native renderer with no JS error.
                    while (rowImgs.length < imagesPerRow) {
                        rowImgs.push(null);
                    }
                    rows.push(rowImgs);
                }
            } else {
                rows.push(item.IMGS);
            }


            let lnRows = rows.length > 2 ? 2 : rows.length;
            let thumbsHeight = (lnRows - 1) * (thumbSize + 10); // 10px margin bottom
            let imgWidth = part1Width - 40;
            let imgHeight = imgWidth - thumbsHeight;
            let dim = Math.min(imgWidth, imgHeight);
            dim = Math.max(dim, 150); // guard against negative/zero size (e.g. short viewport in landscape) crashing the native Slideshow ScrollView

            return (
                <View style={{ flexDirection: 'row', borderRadius: 12, marginHorizontal: 20, minHeight: height, height }}>
                    {/* /* Left: Slideshow (50% width) */}
                    <View style={{ width: part1Width, minWidth, backgroundColor: '#FFF' }}>
                        <ScrollView
                            style={{
                                width: part1Width,
                                height: height,
                                minWidth,
                            }}
                            contentContainerStyle={{
                                alignItems: 'center',
                                justifyContent: 'center',
                                minHeight: height
                            }}
                            showsVerticalScrollIndicator={false}
                        >
                            {Styles.renderVSeparator(30)}
                            <Slideshow
                                ref={ref => this.slideshowRef = ref}
                                dataSource={item.IMGS.map(img => ({
                                    url: img,
                                }))}
                                resizeMode="contain"
                                width={dim - 40}
                                imgWidth={dim - 40}
                                height={height - thumbsHeight - 180}
                                arrowRight={<View />}
                                arrowLeft={<View />}
                                arrowSize={24}
                                indicatorSize={8}
                                indicatorColor={AppStyles.appColor5}
                                indicatorSelectedColor={AppStyles.appColor1}
                                autoPlay={false}
                                autoPlayInterval={3000}
                                scrollEnabled={true}
                                containerStyle={{
                                    borderRadius: 12,
                                    overflow: 'hidden',
                                }}
                            // position={this.state.selectedImgIndex || 0}
                            // onPositionChanged={index => this.setState({ selectedImgIndex: index })}
                            />

                            {/* Dynamic image grid with dummy views for even rows */}
                            {this.renderAwaitingRestock(item)}
                            {item.IMGS && item.IMGS.length > 0 &&
                                <View style={{ marginTop: 25 }}>
                                    {rows.map((rowImgs, rowIdx) => (
                                        <View key={rowIdx} style={{ flexDirection: 'row', gap: 8, justifyContent: 'center', alignItems: 'center', marginBottom: 8 }}>
                                            {rowImgs.map((img, idx) => img ? (
                                                <TouchableOpacity
                                                    key={idx}
                                                    onPress={() => {
                                                        this.setState({ selectedImgIndex: rowIdx * imagesPerRow + idx });
                                                        if (this.slideshowRef && this.slideshowRef._move) {
                                                            this.slideshowRef._move(rowIdx * imagesPerRow + idx);
                                                        }
                                                    }}
                                                    activeOpacity={0.7}
                                                    style={{
                                                        margin: 5,
                                                        boxShadow: '5px 5px 15px 0 rgba(32, 32, 32, 0.03)',
                                                        backgroundColor: 'white',
                                                        padding: 8,
                                                        borderRadius: 20,
                                                        borderWidth: 2,
                                                        borderColor: this.state.selectedImgIndex === (rowIdx * imagesPerRow + idx) ? AppStyles.appColor1 : 'transparent',
                                                    }}
                                                >
                                                    <Image
                                                        source={{ uri: img }}
                                                        style={{
                                                            width: thumbDim, height: thumbDim, resizeMode: 'contain',
                                                        }}
                                                    />
                                                </TouchableOpacity>
                                            ) : (
                                                <View key={idx} style={{ width: 100 * imgsScale + 20, height: 100 * imgsScale + 20, margin: 5, opacity: 0 }} />
                                            ))}
                                        </View>
                                    ))}
                                </View>
                            }
                        </ScrollView>
                    </View>
                    <ScrollView
                        style={{
                            flex: 1,
                            height,
                            backgroundColor: AppStyles.desktopBackgroundColor,
                            width: '100%',
                        }}
                        contentContainerStyle={{ alignItems: 'center' }}
                        showsVerticalScrollIndicator={false}
                    >
                        <View style={{
                            gap: 25,
                            maxWidth: 500,
                            minHeight: height,
                            position: 'relative',
                            paddingTop: 70,
                            width: part2Width - 40,
                        }}>
                            <View style={{ marginTop: 10, alignItems: 'flex-start' }}>
                                <Text style={[AppStyles.productDetailsTitle, {}]}>
                                    {/* {language && language.startsWith('ar') ? item.BRAND_AR_NAME : item.BRAND_EN_NAME} */}
                                </Text>
                                <Text style={[AppStyles.productDetailsTitle, { textAlign: 'left', textTransform: 'capitalize' }]}>{item.NAME.toLowerCase()}</Text>
                            </View>
                            <View style={{ alignSelf: 'flex-start', gap: 4 }}>
                                <Text style={[AppStyles.priceAmountStyle, {}]}>{item.PHARMACY_PRICE} JOD{<Text style={[AppStyles.priceJODTextStyle]}> (+{item.TAX}% tax)</Text>}
                                </Text>
                                {
                                    item.PUBLIC_PRICE &&
                                    <Text style={[AppStyles.secondPriceAmount, {}]}>RSP {item.PUBLIC_PRICE}
                                        <Text style={[AppStyles.secondPriceJODText]}> JOD</Text>
                                    </Text>
                                }
                                {
                                    item.EXP_DATE && <Text style={[AppStyles.expiryDate, {}]}>{STRINGS.Expiry_Date} {item.EXP_DATE}</Text>
                                }
                            </View>
                            {item.LINKED_ITEMS && item.LINKED_ITEMS.length > 0 && (
                                <View style={{}}>
                                    {/* Split images into rows of 4 */}
                                    {Array.from({ length: Math.ceil(item.LINKED_ITEMS.length / 4) }, (_, rowIdx) => (
                                        <View key={rowIdx} style={{ flexDirection: 'row', gap: 8, marginBottom: 15 }}>
                                            {item.LINKED_ITEMS.slice(rowIdx * 4, rowIdx * 4 + 4).map((linkedItem, xindex) => (
                                                <TouchableOpacity style={{
                                                    justifyContent: 'center', alignItems: 'center', gap: 4
                                                }}
                                                    onPress={() => {
                                                        this.setState({ productID: linkedItem.ID, selectedImgIndex: 0, bonusPlus: 0 }, () => {
                                                            this.loadData();
                                                        });
                                                    }}>
                                                    <Image
                                                        source={{ uri: linkedItem.IMG }}
                                                        style={[{
                                                            width: 100 * linkedImgsScale, height: 100 * linkedImgsScale, borderRadius: 6, resizeMode: 'contain',
                                                            boxShadow: '5px 5px 15px 0 rgba(32, 32, 32, 0.05)',
                                                            marginHorizontal: 7.5,
                                                            borderRadius: 20,
                                                            borderWidth: 2,
                                                            borderColor: (this.state.productID === linkedItem.ID) ? AppStyles.appColor1 : 'transparent',
                                                        }, xindex == 0 && { marginLeft: 0 }]}
                                                    />
                                                    <Text style={[AppStyles.productDetailsSpecText, { width: 100 * linkedImgsScale, textAlign: 'center' }]}>{linkedItem.SPEC}</Text>
                                                </TouchableOpacity>
                                            ))}
                                        </View>
                                    ))}
                                </View>
                            )}

                            {this.renderBonusList(item, bonListRows)}
                            {item.NOTES && <View style={{ gap: 8, alignSelf: 'flex-start', maxWidth: 400 }}>
                                <Text style={[AppStyles.BonusText, { textAlign: 'left' }]}>{STRINGS.Notes}</Text>
                                <Text style={[AppStyles.orderNowTextStyle, { textAlign: 'left' }]}>{item.NOTES}</Text>
                            </View>}
                            {Styles.renderVSeparator(60)}
                        </View>
                        {this.addToCartButton(this.state.product, this.state.productID)}
                    </ScrollView>
                </View >
            )
        } catch (error) {
            console.error('[ProductDetails.renderPart1] crashed, showing fallback:', error && error.message, error && error.stack);
            return (
                <View style={{ padding: 40, alignItems: 'center' }}>
                    <Text style={{ fontSize: 16 }}>Something went wrong loading this product.</Text>
                </View>
            );
        }
    }

    renderBonusList = (item, bonListRows) => {
        return (item.BON_LIST && item.BON_LIST.length > 0 && (
            <View style={{ gap: 8, alignSelf: 'flex-start', width: width - 34 }}>
                <Text style={[AppStyles.BonusText, { textAlign: 'left' }]}>{STRINGS.Bonus}</Text>
                <ScrollView horizontal showsHorizontalScrollIndicator={false} style={{ paddingRight: 32 }}>
                    {bonListRows.map((row, rowIdx) => (
                        <View key={rowIdx} style={{ flexDirection: 'row', gap: 8, marginBottom: 8 }}>
                            {row.map((bonus, idx) => {
                                let bgColor = '#F2A197';
                                console.log('bonus', bonus);
                                console.log('item', item);
                                if (item.BONUS_TEXT === (bonus.TEXT) && item.BONUS_TEXT !== '') {
                                    bgColor = '#6BA461';
                                }
                                return (
                                    <TouchableOpacity
                                        key={idx}
                                        onPress={async () => {
                                            this.setState(prevState => ({
                                                bonusAdded: {
                                                    ...(prevState.bonusAdded || {}),
                                                    [item.ID]: true
                                                }
                                            }));
                                            this.setState(async prevState => {
                                                const product = { ...prevState.product, qty: bonus.QTY };
                                                this.updateProduct(product);
                                                return { product };
                                            });
                                        }}
                                        style={{
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            minWidth: 73,
                                            paddingHorizontal: 12,
                                            height: 40,
                                            backgroundColor: bgColor,
                                            borderRadius: 8
                                        }}>
                                        <Text style={[AppStyles.bonusBoxText]}>{bonus.TEXT}</Text>
                                    </TouchableOpacity>
                                );
                            })}
                            {row.length < 3 &&
                                Array.from({ length: 3 - row.length }).map((_, i) => (
                                    <View key={`empty-${i}`} style={{ width: 80, height: 40 }} />
                                ))
                            }
                        </View>
                    ))}
                </ScrollView>
            </View>
        ));
    }



    renderPart1Mobile = () => {
        const item = this.state.products && this.state.products[0] || "X";
        console.log('renderPart1Mobile item', item);
        if (item == "X") {
            return null;
        }

        try {

            // Split BON_LIST into rows of 3 items each, guarding against BON_LIST
            // sometimes being a non-array (e.g. an empty string) from the API.
            const bonListRows = Array.isArray(item.BON_LIST)
                ? Array.from({ length: Math.ceil(item.BON_LIST.length / 6) }, (_, i) =>
                    item.BON_LIST.slice(i * 4, i * 4 + 4)
                )
                : [];

            part1Width = width;
            part2Width = part1Width;
            let minWidth = part1Width;


            let imgsScale = (Math.max(part1Width, minWidth) - 40) / item.IMGS.length / 116;
            imgsScale = 1;
            if (imgsScale > 1) imgsScale = 1;
            if (imgsScale < 0.7) imgsScale = 0.7;

            let linkedImgsScale = (part2Width - 70) / 4 / 116;
            if (linkedImgsScale > 1) linkedImgsScale = 1;
            if (linkedImgsScale < 0.6) linkedImgsScale = 0.6;

            const thumbDim = 80 * imgsScale;
            const thumbSize = thumbDim + 20; // 90px image + 10px padding each side
            const rows = [];


            let lnRows = rows.length > 2 ? 2 : rows.length;
            let thumbsHeight = 0 * (lnRows - 1) * (thumbSize + 10); // 10px margin bottom
            let imgWidth = part1Width - 32;
            let imgHeight = height - 440;
            let dim = Math.min(imgWidth, imgHeight);
            dim = Math.max(dim, 150); // guard against negative/zero size (e.g. short viewport in landscape) crashing the native Slideshow ScrollView

            return (
                <View style={{ borderRadius: 12, height: height - 40, backgroundColor: AppStyles.desktopBackgroundColor }}>
                    {/* /* Left: Slideshow (50% width) */}
                    <View style={{
                        width: part1Width,
                        alignContent: 'center',
                        alignItems: 'center',
                        justifyContent: 'center',
                        borderRadius: 20
                    }}>
                        {Styles.renderVSeparator(20)}
                        {this.renderAwaitingRestock(item)}
                        <Slideshow
                            ref={ref => this.slideshowRef = ref}
                            dataSource={item.IMGS.map(img => ({
                                url: img,
                            }))}
                            resizeMode="contain"
                            width={dim}
                            imgWidth={dim}
                            height={dim + 70}
                            arrowRight={<View />}
                            arrowLeft={<View />}
                            arrowSize={24}
                            indicatorSize={8}
                            indicatorColor={AppStyles.appColor5}
                            indicatorSelectedColor={AppStyles.appColor1}
                            autoPlay={false}
                            autoPlayInterval={3000}
                            scrollEnabled={true}
                            containerStyle={{
                                borderRadius: 12,
                                overflow: 'hidden',
                            }}
                        // position={this.state.selectedImgIndex || 0}
                        // onPositionChanged={index => this.setState({ selectedImgIndex: index })}
                        />
                    </View>
                    <View
                        style={{
                            width,
                            backgroundColor: AppStyles.desktopBackgroundColor,
                        }}
                    >
                        <View style={{
                            gap: 25,
                            position: 'relative',
                            width: part2Width - 60,
                            paddingHorizontal: 30
                        }}>
                            <View style={{ marginTop: 10, alignItems: 'flex-start' }}>
                                <Text style={[AppStyles.productDetailsTitle, {}]}>
                                    {/* {language && language.startsWith('ar') ? item.BRAND_AR_NAME : item.BRAND_EN_NAME} */}
                                </Text>
                                <Text style={[AppStyles.productDetailsTitle, {
                                    textAlign: 'left', textTransform: 'capitalize', fontSize: 18,
                                    width: part2Width - 60
                                }]}>{item.NAME.toLowerCase()}</Text>
                            </View>
                            <View style={{ alignSelf: 'flex-start', gap: 4, zIndex: 9 }}>
                                <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                                    <Text style={[AppStyles.priceAmountStyle, {}]}>{item.PHARMACY_PRICE} JOD</Text>
                                    <Text style={[AppStyles.priceJODTextStyle]}> (+{item.TAX}% tax)</Text>
                                </View>
                                {
                                    item.PUBLIC_PRICE &&
                                    <Text style={[AppStyles.secondPriceAmount, {}]}>RSP {item.PUBLIC_PRICE}
                                        <Text style={[AppStyles.secondPriceJODText]}> JOD</Text>
                                    </Text>
                                }
                                {
                                    item.EXP_DATE && <Text style={[AppStyles.expiryDate, {}]}>{STRINGS.Expiry_Date} {item.EXP_DATE}</Text>
                                }
                            </View>
                            {item.LINKED_ITEMS && item.LINKED_ITEMS.length > 0 && (
                                <View style={{}}>
                                    {/* Split images into rows of 4 */}
                                    {Array.from({ length: Math.ceil(item.LINKED_ITEMS.length / 4) }, (_, rowIdx) => (
                                        <View key={rowIdx} style={{ flexDirection: 'row', gap: 8, marginBottom: 15 }}>
                                            {item.LINKED_ITEMS.slice(rowIdx * 4, rowIdx * 4 + 4).map((linkedItem, xindex) => (
                                                <TouchableOpacity style={{
                                                    justifyContent: 'center', alignItems: 'center', gap: 4
                                                }}
                                                    onPress={() => {
                                                        this.setState({ productID: linkedItem.ID, selectedImgIndex: 0, bonusPlus: 0 }, () => {
                                                            this.loadData();
                                                        });
                                                    }}>
                                                    <Image
                                                        source={{ uri: linkedItem.IMG }}
                                                        style={[{
                                                            width: 100 * linkedImgsScale, height: 100 * linkedImgsScale, borderRadius: 6, resizeMode: 'contain',
                                                            boxShadow: '5px 5px 15px 0 rgba(32, 32, 32, 0.05)',
                                                            marginHorizontal: 7.5,
                                                            borderRadius: 20,
                                                            borderWidth: 2,
                                                            borderColor: (this.state.productID === linkedItem.ID) ? AppStyles.appColor1 : 'transparent',
                                                        }, xindex == 0 && { marginLeft: 0 }]}
                                                    />
                                                    <Text style={[AppStyles.productDetailsSpecText, { width: 100 * linkedImgsScale, textAlign: 'center' }]}>{linkedItem.SPEC}</Text>
                                                </TouchableOpacity>
                                            ))}
                                        </View>
                                    ))}
                                </View>
                            )}

                            {this.renderBonusList(item, bonListRows)}
                            {item.NOTES && <View style={{ gap: 8, alignSelf: 'flex-start', maxWidth: 400 }}>
                                <Text style={[AppStyles.BonusText, { textAlign: 'left' }]}>{STRINGS.Notes}</Text>
                                <Text style={[AppStyles.orderNowTextStyle, { textAlign: 'left' }]}>{item.NOTES}</Text>
                            </View>}
                            {Styles.renderVSeparator(60)}
                        </View>
                    </View>
                </View >
            )
        } catch (error) {
            console.error('[ProductDetails.renderPart1Mobile] crashed, showing fallback:', error && error.message, error && error.stack);
            return (
                <View style={{ padding: 40, alignItems: 'center' }}>
                    <Text style={{ fontSize: 16 }}>Something went wrong loading this product.</Text>
                </View>
            );
        }
    }

    addToCartButton = (item, itemID) => {
        let qty = this.state[`itemQty${item.ID}`] && this.state[`itemQty${item.ID}`] ? this.state[`itemQty${item.ID}`] : 1;
        if (this.state[`cartPressed_${item.ID}`] === undefined) {
            this.state[`cartPressed_${item.ID}`] = Commons.checkItemIsInBasket(this, item.ID).inBasket;
        }
        if (!this[`qtyAnimRef_${itemID}`]) this[`qtyAnimRef_${itemID}`] = React.createRef();

        return (
            <SafeAreaInsetsContext.Consumer>
                {(insets) => {
                    return (
                    <View style={{
                        justifyContent: 'center',
                        alignItems: 'center',
                        alignSelf: 'stretch',
                        paddingHorizontal: isMobile ? 20 : 0,
                        paddingTop: isMobile ? 16 : 0,
                        // Android reports the keyboard height without the navigation bar, so add it back.
                        marginBottom: isMobile && this.state.keyboardHeight > 0
                            ? this.state.keyboardHeight + (Platform.OS === 'android' ? (insets?.bottom || 0) : 0)
                            : 0,
                        paddingBottom: isMobile
                            ? (this.state.keyboardHeight > 0 ? 16 : Math.max((insets?.bottom || 0) + 16, 24))
                            : 20,
                        backgroundColor: isMobile ? AppStyles.desktopBackgroundColor : undefined,
                    }}>
                        {item.BONUS > 0 && (
                            <View style={{ justifyContent: 'center', alignItems: 'center', flexDirection: 'row', }}>
                                <Image source={giftIcon} style={{ width: 14, height: 14 }} />
                                <Text style={[AppStyles.giftText]}> +{item.BONUS}</Text>
                            </View>
                        )}
                        {!this.state[`cartPressed_${item.ID}`] && (
                            <TouchableOpacity
                                style={[AppStyles.loginButtonStyles, { width: isMobile ? '100%' : part2Width - 20, maxWidth: 440, marginTop: 8, backgroundColor: '#6BA461' }]}
                                onPress={() => {
                                    item.qty = qty;
                                    Commons.addItemsToBasket(this, item, item.ID, qty);
                                    this.setState({ [`cartPressed_${itemID}`]: true, itemsNo: this.state.itemsNo + 1, });
                                    this.setState(prevState => {
                                        const product = { ...prevState.product, qty: qty };
                                        this.updateProduct(product);
                                        return { product };
                                    });
                                }}
                            >
                                <Text style={AppStyles.loginButtonTextStyles}>{STRINGS.add_to_cart}</Text>
                            </TouchableOpacity>
                        )}
                        {this.state[`cartPressed_${item.ID}`] && (
                            <View style={[AppStyles.loginButtonStyles, {
                                width: isMobile ? '100%' : part2Width - 20, maxWidth: 440,
                                flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', marginTop: 8, backgroundColor: '#6BA461'
                            }]}>
                                <TouchableOpacity
                                    onPress={async () => {
                                        this.state[`itemQty${itemID}`] = (this.state[`itemQty${itemID}`] || 1) - 1;
                                        if (this.state[`itemQty${itemID}`] <= 0) {
                                            this.setState(prevState => {
                                                const tempQty = { ...(prevState.tempQty || {}) };
                                                tempQty[itemID] = Math.max((tempQty[itemID] || 0) - 1, 0);
                                                // self.state[`itemQty${itemID}`] = (self.state[`itemQty${itemID}`] || 1) - 1;
                                                return {
                                                    tempQty,
                                                    [`cartPressed_${itemID}`]: !prevState[`cartPressed_${itemID}`],
                                                    itemsNo: this.state.itemsNo - 1,
                                                };
                                            });
                                            this.deleteProduct();
                                        } else {
                                            this.setState(prevState => {
                                                const tempQty = { ...(prevState.tempQty || {}) };
                                                tempQty[itemID] = (tempQty[itemID] || 1) - 1;
                                                const product = { ...prevState.product, qty: qty - 1 };
                                                this.updateProduct(product);
                                                return { product };
                                            });
                                        }
                                    }}
                                    style={{ padding: 12, paddingLeft: 6 }}
                                >
                                    <Image source={minus} style={{ width: 12, height: 2, tintColor: '#FFF' }} />
                                </TouchableOpacity>
                                {/* <Animatable.Text
                            ref={this[`qtyAnimRef_${itemID}`]}
                            style={{ color: '#FFF', fontFamily: AppStyles.fontFamily, fontSize: 16, fontStyle: 'normal', fontWeight: '700'}}>
                            {qty || 1}
                        </Animatable.Text> */}
                                <View style={{ zIndex: 3, minWidth: 56, height: 44, paddingHorizontal: 8, justifyContent: 'center', alignItems: 'center' }}>
                                    <TextInput
                                        ref={this[`qtyAnimRef_${itemID}`]}
                                        style={[
                                            AppStyles.featuredItemsQtyStyle,
                                            { textAlign: 'center', padding: 0, margin: 0, backgroundColor: 'transparent', minWidth: 56, height: 44 }
                                        ]}
                                        // value={qty.toString()}
                                        keyboardType={"number-pad"}
                                        selectTextOnFocus={true}
                                        value={this.state[`itemQty${itemID}`] ? this.state[`itemQty${itemID}`].toString() : 1}
                                        onFocus={() => this.focusQtyInput(itemID)}
                                        onBlur={() => this.setState({ qtyInputFocused: false })}
                                        onChangeText={async (text) => {
                                            // Only allow numbers
                                            let newQty = parseInt(text.replace(/[^0-9]/g, ''), 10);
                                            if (isNaN(newQty) || newQty <= 0) {
                                                this.setState(prevState => {
                                                    const tempQty = { ...(prevState.tempQty || {}) };
                                                    tempQty[itemID] = Math.max((tempQty[itemID] || 0) - 1, 0);
                                                    return {
                                                        tempQty,
                                                        [`cartPressed_${itemID}`]: !prevState[`cartPressed_${itemID}`],
                                                        itemsNo: this.state.itemsNo - 1,
                                                    };
                                                });
                                                this.deleteProduct();
                                                // await Commons.updateItemsNo(this, "", '');
                                                // itemsNo(await Commons.updateItemsNo(this, "", ''));
                                            } else {
                                                this.state[`itemQty${itemID}`] = newQty;
                                                this.setState(prevState => {
                                                    const tempQty = { ...(prevState.tempQty || {}) };
                                                    tempQty[itemID] = newQty;
                                                    return { tempQty };
                                                });
                                                item.qty = newQty;
                                                // await Commons.updateItemsNo(this, "add", qty);
                                                // itemsNo(await Commons.updateItemsNo(this, "", ''));
                                                this.updateProduct(item);
                                            }

                                        }}
                                    />
                                </View>
                                <TouchableOpacity
                                    onPress={() => {
                                        // if (this[`qtyAnimRef_${itemID}`] && this[`qtyAnimRef_${itemID}`].current) {
                                        //     this[`qtyAnimRef_${itemID}`].current.bounce(100);
                                        // }
                                        this.setState(prevState => {
                                            const tempQty = { ...(prevState.tempQty || {}) };
                                            tempQty[itemID] = (tempQty[itemID] || 1) + 1;
                                            this.state[`itemQty${itemID}`] = (this.state[`itemQty${itemID}`] || 1) + 1;
                                            const product = { ...prevState.product, qty: qty + 1 };
                                            this.updateProduct(product);
                                            return { product };
                                        });
                                    }}
                                    style={{ padding: 12, paddingRight: 6 }}
                                >
                                    <Image source={plus} style={{ width: 12, height: 12, tintColor: '#FFF' }} />
                                </TouchableOpacity>
                            </View>
                        )}
                    </View>
                    )
                }}
            </SafeAreaInsetsContext.Consumer>
        )
    };



    styles = () => ({
        container: {
            flex: 1,
            alignItems: "center",
            backgroundColor: AppStyles.desktopBackgroundColor,
        },
        image: {
            flex: 1,
            resizeMode: 'contain',
            justifyContent: 'center',
            height: 590,
        }
    });
}



export default ProductDetails;
